module.exports = __webpack_public_path__ + "static/media/middle-new.3c7bb490.png";